import React, { createContext, useState, useEffect } from "react";
import AxiosApiCall from "../api/AxiosApiCall";
import ApiServices from "../api/ApiServices";
import { toast } from "react-toastify";
import Spinner from "../pages/spinner/Spinner";


export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const storedAuth = localStorage.getItem("auth");
    return storedAuth ? JSON.parse(storedAuth) : null;
  });

  const [permissions, setPermissions] = useState(() => {
    const storedPermissions = localStorage.getItem("permissions");
    return storedPermissions ? JSON.parse(storedPermissions) : [];
  });
  const [loading, setLoading] = useState(!localStorage.getItem("auth"));

  useEffect(() => {
    if (localStorage.getItem("auth") && !localStorage.getItem("permissions")) {
      const fetchPermissions = async () => {
        try {
          const storedAuth = JSON.parse(localStorage.getItem("auth"));
          const token = storedAuth?.token;
          const admin_id = storedAuth?.user;
          if (!token || !admin_id) {
            throw new Error("No access token or admin_id found.");
          }

  const axios = AxiosApiCall();
          const response = await axios.get(ApiServices.getAdminPermissionsByid, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params: { admin_id },
            withCredentials: true,
          });

          const { status, message, data } = response.data;

          if (status === 200) {
            setPermissions(data);
            localStorage.setItem("permissions", JSON.stringify(data));
          } else {
            toast.error(message, { toastId: "permission-fetch-error" });
          }
        } catch (error) {
          toast.error("Failed to fetch permissions");
        } finally {
          setLoading(false);
        }
      };

      fetchPermissions();
    } else {
      setLoading(false);
    }
  }, []);

  const logout = () => {
    setAuth(null);
    setPermissions([]);
    localStorage.removeItem("auth");
    localStorage.removeItem("user_id");
    localStorage.removeItem("portal");
    localStorage.removeItem("permissions");
  };

  // useEffect(() => {
  //   console.log('Current User Permissions:', permissions);
  // }, [permissions]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, permissions, setPermissions, logout }}>
      {loading ? (
        <div className="flex justify-center items-center h-screen w-screen">
          <Spinner loading={loading} />
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};


export default AuthProvider;






